import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { LandingPage } from "@/features/landing/LandingPage";
import { FullscreenLoader } from "@/components/ui/loader";

export const Route = createFileRoute("/")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "HAMS — Hospital Asset Management" },
      { name: "description", content: "Asset registry, work orders, compliance & audit for hospitals." },
    ],
  }),
  component: Landing,
});

function Landing() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { isAuthenticated, getMe } = await import("@/integrations/api/auth");
        if (isAuthenticated()) {
          const me = await getMe();
          if (cancelled) return;
          const { homePathForRoles } = await import("@/lib/roles");
          navigate({ to: homePathForRoles(me.roles) });
          return;
        }
      } catch {
        // Not logged in or session expired
      }
      if (!cancelled) setChecking(false);
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  if (checking) {
    return <FullscreenLoader />;
  }

  return <LandingPage />;
}
